import { initializeIcons } from '@fluentui/react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import { AppStateProvider } from './state/AppProvider'

import { StyledEngineProvider } from '@mui/material'
import AdminGuard from './components/AdminGuard'
import MicroLearningGuard from './components/MicroLearningGuard'
import { GradientDefs } from './components/GradientDefs'
import './index.css'
import AccessRequestManagement from './pages/AccessRequestManagement/AccessRequestManagement'
import AdoptionDashboard from './pages/AdoptionDashboard/AdoptionDashboard'
import ApplicationAnalytics from './pages/ApplicationAnalytics/ApplicationAnalytics'
import ExperimentRedirect from './pages/experiments/ExperimentRedirect'
import Experiments from './pages/experiments/Experiments'
import Home from './pages/home/Home'
import MicroLearnings from './pages/MicroLearnings/MicroLearnings'
import MicroLearningDetail from './pages/MicroLearningDetail/MicroLearningDetail'
import ReleaseUpdates from './pages/ReleaseUpdates/ReleaseUpdates'
import UsersRolesAndPermissionsManagement from './pages/UsersRolesAndPermissionsManagement/UsersRolesAndPermissionsManagement'
initializeIcons()

export default function App() {
  return (
    <StyledEngineProvider injectFirst>
      <GradientDefs />
      <AppStateProvider>
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            <Route
              path="/app"
              element={<Layout />}>
              <Route
                index
                element={<Chat />}
              />
              <Route
                path="/app/experiments"
                element={<Experiments />}
              />
              <Route
                path="/app/experiments/:experimentCode"
                element={<ExperimentRedirect />}
              />
              <Route
                path="/app/access-request-management"
                element={
                  <AdminGuard>
                    <AccessRequestManagement />
                  </AdminGuard>
                }
              />
              <Route
                path="/app/users-roles-and-permissions-management"
                element={
                  <AdminGuard>
                    <UsersRolesAndPermissionsManagement />
                  </AdminGuard>
                }
              />
              <Route
                path="/app/application-analytics"
                element={
                  <AdminGuard isOnlyAdminAllowed={true}>
                    <ApplicationAnalytics />
                  </AdminGuard>
                }
              />
              <Route
                path="/app/adoption-dashboard"
                element={<AdoptionDashboard />}
              />
              <Route
                path="/app/micro-learnings"
                element={
                  <MicroLearningGuard>
                    <MicroLearnings />
                  </MicroLearningGuard>
                }
              />
              <Route
                path="/app/micro-learnings/:mlId"
                element={
                  <MicroLearningGuard>
                    <MicroLearningDetail />
                  </MicroLearningGuard>
                }
              />
              <Route
                path="/app/release-updates"
                element={<ReleaseUpdates />}
              />
              <Route
                path="*"
                element={<NoPage />}
              />
            </Route>
          </Routes>
        </HashRouter>
      </AppStateProvider>
    </StyledEngineProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
)
